import request from '@/utils/request';
import { mockData } from './mockData';
// TODO: need to change to get fake data

const urlParams = new URLSearchParams(window.location.search)
const isMock = urlParams.get('mock') === '1';
const sourceFn = params => {
  if (isMock) {
    return new Promise(resolve => {
      const testData = mockData;
      setTimeout(() => {
        resolve(testData);
      }, 0);
    });
  }

  return request({
    url: '/year_end_sharing_2025/get_data',
    method: 'get',
    params
  });
};

export function getReport(params) {
  return sourceFn(params).then(res => {
    const data = res.data;
    return {
      code: res.code,
      version: data.version,
      user: {
        uid: data.uid,
        nickname: data.nickname,
        headimgurl: data.headimgurl,
        loginDay: data.login_day_num,
        loginTime: params.loginTime || setTimePart(data.login_time_part)
      },
      firstHand: setFirstHand(data),
      totalHand: setTotalHand(data),
      maxHand: {
        date: data.max_play_date,
        hands: data.max_play_hand_num
      },
      preferred: {
        game: data.preferred_type,
        hands: data.preferred_hand_num
      },
      victory: setVictory(data),
      achievement: setAchievement(data),
      luckyHand: setLuckyHand(data)
      // kkclash: setKkclash(data),
      // trophy: setTrophy(data)
    };
  });
}

export function checkIpLegal(params) {
  return request({
    url: `/poker-api/checkIpLegal`,
    method: 'get',
    params
  });
}

export function screenApi(params) {
  return request({
    url: `/year_end_sharing_2023/get_screenshot`,
    method: 'get',
    params
  });
}

function toPercentage(value) {
  return (Math.floor(value / 10) / 10).toFixed(1);
}

// time_part 要说明一下
// time_part 是0~143
// -- $n = $now - $now%86400;
// -- $a = $time_part * 600;
// -- echo date('H:i', $n+$a) . PHP_EOL;
function setTimePart(timePart = 0) {
  // const timeOffset = new Date().getTimezoneOffset() * 60000;
  let now = Date.now();
  const n = now - (now % 86400000);
  const a = timePart * 600000;
  const d = new Date(n + a);
  let hour = d.getHours();
  if (hour < 10) {
    hour = '0' + hour;
  }
  let min = d.getMinutes();
  if (min < 10) {
    min = '0' + min;
  }
  return hour + ':' + min;
}

function setFirstHand(data) {
  let type = data.first_play_type;
  let text = 'report.firstHandDate';
  // if(type === 'SK') {
  //   type = 'KKClash'
  //   text = "report.firstClash"
  // }
  return {
    text: text,
    loginDay: data.first_login_date,
    date: data.first_play_date,
    game: type,
    handCards: data.first_hand_cards
  };
}

function setTotalHand(data) {
  const hands = data.total_hand_num;
  const percentage = toPercentage(data.total_hand_percent);

  let text = 'hands.v3';
  if (percentage > 50) {
    text = 'hands.v1';
  } else if (percentage > 10) {
    text = 'hands.v2';
  }
  return {
    text,
    hands,
    percentage
  };
}

function setKkclash(data) {
  const kkclashHand = data.total_bet_num;
  const percentage = toPercentage(data.total_bet_percent);
  const blockKey = data.preferred_block;
  const betNum = data.preferred_bet_num;
  let text = 'kkclash.v2.text1';
  let text_2 = 'kkclash.v2.text2';
  if (percentage > 30) {
    text = 'kkclash.v1.text1';
    text_2 = 'kkclash.v1.text2';
  }
  const blockNameMapping = {
    shark: 'Shark',
    draw: 'Draw',
    king: 'King',
    suited_connector: 'Suited / Connector',
    pocket_pair: 'Pocket Pair',
    pocket_kings: 'Pocket Kings',
    high_card_pair: 'High Card / Pair',
    two_pair: 'Two Pair',
    three_of_a_king_straight_flush: 'Three of a King / Straight / Flush',
    k_high_card_k_pair: 'K High Card / K Pair',
    full_house_or_above: 'Full House or above',
    k_full_house_k_quads: 'K Full House / K Quads'
  };
  return {
    text,
    text_2,
    block: blockNameMapping[blockKey] || '',
    betNum,
    kkclashHand,
    percentage
  };
}

function setVictory(data) {
  const kkHand = data.kk_hand_num;
  const allInNum = data.allin_num;

  let arr = [];

  if (kkHand >= 1) {
    arr.push({
      image: require('@img/keyVisual/bg_8_kk.png'),
      text: 'kkWin.v1',
      all: kkHand,
      win: data.kk_win_num,
      unit1: 'unit.longTimes',
      unit2: 'unit.longTimesTwo'
    });
  }
  if (allInNum >= 1) {
    arr.push({
      image: require('@img/keyVisual/bg_8_allin.png'),
      text: 'kkWin.v2',
      all: allInNum,
      win: '',
      // win: data[toCamelCase("allin_win_num")],
      unit1: 'unit.threeTimes',
      unit2: '',
      percentage: toPercentage(data.allin_win_rate)
    });
  }

  return arr;
}

function setAchievement(data) {
  const isSpinup = data.spinup_date !== undefined;
  const isMtt = data.mtt_date !== undefined;
  const isRg = data.rg_date !== undefined;
  let spinup = {};
  let mtt = {};
  let rg = {};
  if (isSpinup) {
    spinup = {
      text: 'achievement.spinup',
      text_2: 'achievement.spinup_2',
      date: data.spinup_date,
      ratio: data.spinup_ratio,
      reward: data.spinup_reward
    };
  }
  if (isMtt) {
    mtt = {
      text: 'achievement.mtt',
      text_2: 'achievement.mtt_2',
      date: data.mtt_date,
      name: data.mtt_name,
      rank: data.mtt_rank,
      reward: data.mtt_reward
    };
  }
  if (isRg) {
    rg = {
      text: 'achievement.rg',
      text_2: 'achievement.rg_2',
      date: data.rg_date,
      reward: data.rg_pool_size
    };
  }
  return {
    spinup,
    mtt,
    rg
  };
}

function setLuckyHand(data) {
  return {
    loseHand: data.luck_lose_hand,
    loseRate: data.luck_lose_rate,
    winHand: data.luck_win_hand,
    winRate: data.luck_win_rate,
  }
}

function setTrophy(data) {
  const list = data.achievement_list || [];
  const totalTrophy = list.length || 0;
  let type = 'gold';

  const trophyList = list.map(x => {
    if (x.trophy_type === 1) {
      type = 'bronze';
    } else if (x.trophy_type === 2) {
      type = 'silver';
    }
    const nameMapping = {
      trophy_livetokyo2023: 'Live Tokyo',
      trophy_liveosaka2023: 'Live Osaka',
      trophy_montreal_main: 'LIVE MONTREAL MAIN',
      trophy_anniversary2023: 'Crown',
      trophy_jp_fight: '日本チャンピオン'
    };
    const className = x.achievement_name;

    return {
      current: x.current_num,
      total: x.target_num,
      name: nameMapping[className] || className,
      type: type
    };
  });
  return {
    totalTrophy,
    trophyList
  };
}
